import React from "react";
import SocialMediaLink from "./SocialMediaLink";

const SocialMedia = () => (
  <ul className="grid grid-cols-5 gap-x-[8px] w-max">
    {window &&
      // @ts-ignore
      window.WANTABLE_footer.socialMedia.map((link, index) => (
        <SocialMediaLink key={index} {...link} />
      ))}
  </ul>
);

export default SocialMedia;
